import {Hero} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Hero';
import {Inline} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline';

type Props = {
  category: string;
  content: Record<string, string>;
};

export const Base = ({category, content, ...props}: Props) => {
  if (category === 'inline') {
    return (
      <Inline
        {...props}
        title={content.ctHeading}
        subtitle={content.ctSubheading}
        image={content.ctImage}
        logo={content.ctLogo}
      />
    );
  }
  return (
    <Hero
      {...props}
      title={content.ctHeading}
      subtitle={content.ctSubheading}
      image={content.ctImage}
      logo={content.ctLogo}
    />
  );
};
